import { PortfolioFacilitiesStore } from '~/core/routes/credit-facilities/PortfolioFacilitiesProvider';

export const getAppliedFiltersCount = (store: PortfolioFacilitiesStore) => {
  return (Object.keys(
    store.filters.staticFilters,
  ) as (keyof PortfolioFacilitiesStore['filters']['staticFilters'])[]).reduce(
    (count, key) => {
      const filter = JSON.stringify(store.filters.staticFilters[key]);
      const initialValue = JSON.stringify(
        store.initialFilters.staticFilters[key],
      );

      return filter === initialValue ? count : count + 1;
    },
    0,
  );
};
